export enum FeatureFlag {
  BILLING_USAGE_REVAMP = 'billing-usage-revamp',
  BILLING_USAGE_DAILY_HISTORY = 'billing-usage-daily-history',
  CLOUD_COMPASS_RENEWAL = 'cloud-compass-renewal'
}

export const localFeatureFlagValues = {
  [FeatureFlag.BILLING_USAGE_REVAMP]: false,
  [FeatureFlag.BILLING_USAGE_DAILY_HISTORY]: false,
  [FeatureFlag.CLOUD_COMPASS_RENEWAL]: false
};

export type FeatureFlags = typeof localFeatureFlagValues;

export const FEATURE_FLAG_OVERRIDES_STORAGE_KEY = 'ENV0_FEATURE_FLAG_OVERRIDES';

export const readFeatureFlagOverrides = (): Partial<FeatureFlags> => {
  try {
    const stored = localStorage.getItem(FEATURE_FLAG_OVERRIDES_STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
};
